import Cookies from "js-cookie";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  AddParticipants,
  FetchSecurityMaster,
  deleteParticipant,
  updateParticipant,
  updateParticipantsData,
} from "../../api/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import _ from "lodash";
import { Button } from "../../components/Button/Button";
import { useGetFundList, useGetParticipantList } from "../../data/data";
import { Container, Offcanvas, Modal } from "react-bootstrap";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";
export interface IOlympicData {
  symbol: string;
  date: any;
  status: string;
  order: string;
  qty: string;
  price: number;
}
interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}

const AddParticipant = () => {
  const [showmsg, setShowmsg] = useState(false);
  const [showmsgError, setShowErrormsg] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [fundData, setFundData] = useState<any>();
  const [participantData, setParticipantData] = useState<any>();
  const [isActive, setIsActive] = useState(false);
  const [first, setfirst] = useState();
  const [myArray, setMyArray] = useState({});
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [selectedFundID, setSelectedFundID] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedParticipantData, setSelectedParticipantData] =
    useState<any>(null);
  const [filterFundId, setFilterFundId] = useState<any>(null);
  const [editParticipantsID, setEditParticipantsID] = useState<any>(null);
  const selectedClient: any = Cookies.get("client");
  const dataGridRefMain = useRef<AgGridReact<IOlympicData>>(null);
  const {
    data: fundList,
    isFetching: fundFetching,
    refetch: fundRefetch,
  } = useGetFundList("Fund", parseInt(selectedClient), Cookies.get("newJwt"));
  const {
    data: participantList,
    isFetching: participantFetching,
    refetch: participantRefetch,
  } = useGetParticipantList(
    "FundParticipant",
    parseInt(selectedClient),
    Cookies.get("newJwt")
  );
  const [test, setTest] = useState<any>(null);
  const handleCheckboxChange = (e: any) => {
    setIsActive(e.target.checked);
  };

  const [clickedValues, setClickedValues] = useState([]);
  // const handleFundType = (item: any) => {
  //   const isSelected = selectedRows.includes(item);
  //   let updatedSelectedRows;

  //   if (isSelected) {
  //     updatedSelectedRows = selectedRows.filter((row: any) => row !== item); // Remove item from selected rows
  //   } else {
  //     updatedSelectedRows = [...selectedRows, item]; // Add item to selected rows
  //   }

  //   setSelectedRows(updatedSelectedRows);
  // };

  const previousFundRecord = _.find(test, {
    participantID: editParticipantsID,
  });

  const addedFunds: any = _.difference(
    selectedParticipantData?.fundID,
    previousFundRecord?.fundID,
    "fundID"
  );
  const removedFunds: any = _.difference(
    previousFundRecord?.fundID,
    selectedParticipantData?.fundID,
    "fundID"
  );
  const uniqueFundsArray = _.uniq(removedFunds);

  function handleAddFund(e: any) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const payload = Object.fromEntries(formData.entries());
    const newpayload = {
      //isActive: isActive,
      //funds: selectedRows === "" ? selectedRows : selectedParticipantData?.fund,
      removeFundIds: uniqueFundsArray,
      addFundIds: addedFunds,
      ...payload,
    };
    if (!editParticipantsID) {
      AddParticipants(newpayload, Cookies.get("newJwt"))
        .then((response) => response.text())
        .then((response) => {
          const responseObject = JSON.parse(response);
          // Check if the object has an "errors" property
          //responseObject.errors[0].message
          if ("errors" in responseObject) {
            toast.error("Error: " + responseObject.errors[0].message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else {
            toast.success("Participant Created Successfully!", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        });
    }

    if (editParticipantsID) {
      const filteredPayload = Object.fromEntries(
        Object.entries(newpayload).filter(
          ([key, value]) => value !== "" && value !== undefined
        )
      );
      delete filteredPayload?.participantNumber;
      updateParticipantsData(
        editParticipantsID,
        filteredPayload,
        Cookies.get("newJwt")
      )
        .then((response) => response.text())
        .then((response) => {
          if (response === "") {
            toast.success("Participant Updated Successfully!", {
              position: toast.POSITION.TOP_RIGHT,
            });
            participantRefetch();
          } else {
            toast.error("Error in Participant Update", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        });
    }
  }

  useEffect(() => {
    // if (participantList) {
    //   const rearrangedFundList = participantList?.flatMap((participant:any) => {
    //     const participantFunds = participant.fund;
    //     const filteredFunds = fundList?.filter((fund:any) =>
    //       participantFunds.includes(fund.fundID)
    //     );
    //     return filteredFunds.map((filteredFund:any) => ({
    //       ...filteredFund,
    //       participantID: participant.participantID,
    //       participantNumber: participant.participantNumber,
    //       participantName: participant.participantName,
    //       participantType: participant.participantType,
    //     }));
    //   });
    //   console.log(rearrangedFundList);
    // }

    setFundData(fundList);

    const groupedData = _.chain(participantList)
      .groupBy("participantID")
      .map((group) => ({
        participantID: group[0].participantID,
        participantNumber: group[0].participantNumber,
        participantName: group[0].participantName,
        fundID: _.map(group, "fundID"),
        fundName: group[0].fundName,
        fund: group[0].fund,
        isActive: group[0].isActive,
        openDate: group[0].openDate,
        closeDate: group[0].closeDate,
        participantType: group[0].participantType,
      }))
      .value();
    setParticipantData(groupedData);
    setTest(groupedData);
  }, [participantList, fundList]);

  function handleCloseClick() {
    setShowmsg(false);
  }
  const [showForm, setShowForm] = useState(false);
  const [closeDate, setCloseDate] = useState(false);
  const showAddParticipant = () => {
    setShowForm(true);
    setCloseDate(true);
    setSelectedParticipantData(null);
  };

  function editData(data: any) {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setShowForm(true);
    setEditParticipantsID(data?.data?.participantID);
    //setGetEditMetadataID(id);

    FetchSecurityMaster(
      "FundParticipant",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    ).then((response) => {
      const responseObject = response;
      const groupedData = _.chain(responseObject)
        .groupBy("participantID")
        .map((group) => ({
          participantID: group[0].participantID,
          participantNumber: group[0].participantNumber,
          participantName: group[0].participantName,
          fundID: _.map(group, "fundID"),
          fundName: group[0].fundName,
          fund: group[0].fund,
          isActive: group[0].isActive,
          openDate: group[0].openDate,
          closeDate: group[0].closeDate,
          participantType: group[0].participantType,
        }))
        .value();

      const selectedData = _.find(groupedData, {
        participantID: data?.data?.participantID,
      });
      const selectedFundData = _.find(groupedData, {
        participantID: data?.data?.participantID,
      });
      setSelectedParticipantData(selectedData);
      setFilterFundId(selectedFundData);
    });
    setCloseDate(false);
  }

  function deleteData(data: any) {
    setSelectedFundID(data.data);
    setShowModal(true);
  }
  const handleClose = () => {
    setShowModal(false);
  };
  const handleDelete = () => {
    const id = selectedFundID.participantID;
    deleteParticipant(id, Cookies.get("newJwt"))
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Failed to delete participant");
        }
      })
      .then((data) => {
        setShowModal(false);
        toast.success("Deleted successfully!", {
          position: toast.POSITION.TOP_RIGHT,
        });
        participantRefetch();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Failed to delete participant", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const columns = [
    {
      headerName: "Name",
      field: "fundName",
      //flex: 1,
      floatingFilter: true,
      filter: "agTextColumnFilter",
      width: 300,
    },
    {
      headerName: "Fund Type",
      field: "fundType",
      floatingFilter: true,
      filter: "agSetColumnFilter",
      width: 300,
    },
    {
      headerName: "",
      field: "",
      flex: 1,
      cellClass: "text-center",
      // cellRendererFramework: (p: any) => {
      //   const item = p.data.fund;
      //   const isSelected = selectedRows.includes(item);
      //   //const isSelected = selectedParticipantData?.fund.includes(item);
      // console.log(isSelected)
      //   const handleCheckboxChange = () => {
      //     if (isSelected) {
      //       setSelectedRows(selectedRows.filter((row: any) => row !== item));
      //     } else {
      //       setSelectedRows([...selectedRows, item]);
      //     }
      //   };

      //   return (
      //     <input
      //       type="checkbox"
      //       name="fundType"
      //       checked={isSelected}
      //       onChange={handleCheckboxChange}
      //     />
      //   );
      // },
      cellRendererFramework: (p: any) => {
        const item = p.data.fundID;
        const isSelected = selectedParticipantData?.fundID?.includes(item);

        const handleCheckboxChange = () => {
          if (isSelected) {
            const updatedFunds = selectedParticipantData?.fundID.filter(
              (f: string) => f !== item
            );
            setSelectedParticipantData({
              ...selectedParticipantData,
              fundID: updatedFunds,
            });
            setSelectedRows({
              ...selectedParticipantData,
              fundID: updatedFunds,
            });
          } else {
            const updatedFunds = [...selectedParticipantData?.fundID, item];
            setSelectedParticipantData({
              ...selectedParticipantData,
              fundID: updatedFunds,
            });
            setSelectedRows({
              ...selectedParticipantData,
              fundID: updatedFunds,
            });
          }
        };

        return (
          <input
            type="checkbox"
            name="fundType"
            checked={isSelected}
            onChange={handleCheckboxChange}
          />
        );
      },
    },
  ];

  const participantColumns = [
    {
      headerName: "Participant Name",
      field: "participantName",
      //flex: 1,
      floatingFilter: true,
      filter: "agTextColumnFilter",
      width: 250,
    },
    {
      headerName: "Participant Type",
      field: "participantType",
      floatingFilter: true,
      filter: "agSetColumnFilter",
      width: 250,
    },
    {
      headerName: "Status",
      field: "isActive",
      floatingFilter: true,
      filter: "agSetColumnFilter",
      width: 100,
      cellRendererFramework: (p: any) => {
        return p.data.isActive !== null ? (
          p.data.isActive === "Y" ? (
            <span className="text-success ">Active</span>
          ) : (
            "Inactive"
          )
        ) : (
          "--"
        );
      },
    },
    {
      headerName: "Open Date",
      field: "openDate",
      floatingFilter: true,
      filter: "agSetColumnFilter",
      width: 200,
      cellRendererFramework: (p: any) => {
        return p.data.openDate !== null
          ? new Date(p.data.openDate).toLocaleDateString()
          : "--";
      },
    },
    {
      headerName: "Close Date",
      field: "closeDate",
      floatingFilter: true,
      filter: "agSetColumnFilter",
      width: 150,
      cellRendererFramework: (p: any) => {
        return p.data.closeDate !== null ? p.data.closeDate : "--";
      },
    },
    {
      headerName: "Actions",
      field: "",
      flex: 1,
      width: 100,
      //cellClass: "text-center",
      cellRendererFramework: (params: any) => {
        return (
          <>
            <span
              onClick={() => editData({ data: params.data })}
              className="cursor-pointer"
            >
              <i title="edit" className="fas fa-fw fa-edit"></i>
            </span>
            <span
              onClick={() => deleteData({ data: params.data })}
              className="cursor-pointer ml-4"
            >
              <i title="delete" className="fas fa-fw fa-trash"></i>
            </span>
          </>
        );
      },
    },
  ];

  const handleExportExcel = useCallback(() => {
    const params = {
      processCellCallback: (params: any) => {
        if (params.column.colId === "dateColumn") {
          // Format date as desired
          return params.value
            ? new Date(params.value).toLocaleDateString()
            : "";
        }
        if (typeof params.value === "string") {
          // Apply currency symbol to string values
          return `${params.value}`;
        }
        if (typeof params.value === "number") {
          // Format numbers as currency with the currency symbol
          return `$${params.value.toFixed(2)}`;
        }
        if (params.column.colId.includes("Locked")) {
          // Render true/false as text
          return params.value; // or return "" + params.value;
        }

        if (params.column.colId.includes("Status")) {
          // Render true/false as text
          return params.value; // or return "" + params.value;
        }

        if (typeof params.value === "undefined") {
          // Format numbers as currency with the currency symbol
          return `--`;
        }
        return params.value !== null ? `$${params.value}` : "--";
      },
    };

    dataGridRefMain.current?.api.exportDataAsExcel(params);
  }, []);

  const handleExportPdf = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(8);

    const title = "Participant List";
    const headers = [
      [
        "Participant Name",
        "Participant Type",
        "Status",
        "Open Date",
        "Close Date",
      ],
    ];

    const transactionData = participantData.map((e: any) => [
      e.participantName,
      e.participantType !== null ? `${e.participantType}` : "--",
      e.isActive !== null ? `${e.isActive}` : "--",
      e.openDate !== null ? `${e.openDate}` : "--",
      e.closeDate !== null ? `${e.closeDate}` : "--",
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: transactionData,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("Participant.pdf");
  };
  return (
    <div className="w-100">
      <div className="header">
        <h1 className="header-title">Participant</h1>
      </div>
      <div className="row w-100 card py-4 px-2">
        <div className="tradeForm position-relative">
          <div>
            {showmsg ? (
              <div
                className="alert alert-danger alert-dismissible mb-0 mt-4 statusAlert"
                role="alert"
              >
                <div className="alert-message">
                  {showmsgError ? showmsgError : successMessage}
                </div>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                  onClick={handleCloseClick}
                ></button>
              </div>
            ) : null}
            <div className="col-sm-12 d-inline-block">
              <Button
                type="submit"
                className="btn-primary float-end mx-2"
                size="btn-xs"
                children={"Add Participant"}
                //showLoading={isBtnLoading}
                onClick={showAddParticipant}
              />
            </div>

            {showForm ? (
              <>
                <form className="w-100 my-2" onSubmit={handleAddFund}>
                  <div className="row">
                    <label className="mb-3 col-md-2">Participant Number</label>
                    <div className="mb-3 col-md-3">
                      <select
                        className="form-control"
                        name="participantNumber"
                        value={selectedParticipantData?.participantNumber}
                      >
                        <option value="">Select</option>
                        {participantList?.map((e: any) => {
                          return (
                            <option value={e.participantNumber} key={e.fund}>
                              {e.participantNumber}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="row">
                    <label className="mb-3 col-md-2">Participant Name</label>
                    <div className="mb-3 col-md-3">
                      <select
                        className="form-control"
                        name="participantName"
                        value={selectedParticipantData?.participantName}
                      >
                        <option value="">Select</option>
                        {participantList?.map((e: any) => {
                          return (
                            <option value={e.participantName} key={e.fund}>
                              {e.participantName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <label className="mb-3 col-md-2">Participant Type</label>
                    <div className="mb-3 col-md-3">
                      <select
                        className="form-control"
                        name="participantType"
                        value={selectedParticipantData?.participantType || ""}
                        onChange={(event) => {
                          setSelectedParticipantData({
                            ...selectedParticipantData,
                            participantType: event.target.value,
                          });
                        }}
                      >
                        <option value="">Select</option>
                        <option value="Corporation">Corporation</option>
                        <option value="Trust">Trust</option>
                        <option value="Plan">Plan</option>
                        <option value="High-networth">High-Networth</option>
                        <option value="Llc">LLC</option>
                        <option value="Government">Government</option>
                        <option value="Endowment">Endowment</option>
                        <option value="Individual">Individual</option>
                      </select>
                    </div>
                  </div>
                  <div className="row">
                    <label className="mb-3 col-md-2">Is Active</label>
                    <div className="mb-3 col-md-3">
                      <input
                        type="checkbox"
                        checked={
                          selectedParticipantData?.isActive === "Y" ||
                          selectedParticipantData?.isActive === null
                            ? true
                            : isActive
                        }
                        onChange={handleCheckboxChange}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <label className="mb-3 col-md-2 pt-2">Open Date</label>
                    <div className="mb-3 col-md-3">
                      <input
                        type="date"
                        className="form-control"
                        placeholder=""
                        name="openDate"
                        defaultValue={
                          selectedParticipantData?.openDate
                            ? new Date(selectedParticipantData?.openDate)
                                ?.toISOString()
                                .split("T")[0]
                            : ""
                        }
                      ></input>
                    </div>
                    {!closeDate ? (
                      selectedParticipantData?.isActive === "Y" ||
                      selectedParticipantData?.isActive === null ? null : (
                        <>
                          <label className="mb-3 col-md-2 pt-2">
                            Close Date
                          </label>
                          <div className="mb-3 col-md-3">
                            <input
                              type="date"
                              className="form-control"
                              placeholder=""
                              name="closeDate"
                              defaultValue={
                                selectedParticipantData?.closeDate
                                  ? new Date(selectedParticipantData?.closeDate)
                                      ?.toISOString()
                                      .split("T")[0]
                                  : ""
                              }
                            ></input>
                          </div>
                        </>
                      )
                    ) : (
                      <>
                        <label className="mb-3 col-md-2 pt-2">Close Date</label>
                        <div className="mb-3 col-md-3">
                          <input
                            type="date"
                            className="form-control"
                            placeholder=""
                            name="closeDate"
                            defaultValue={
                              selectedParticipantData?.closeDate
                                ? new Date(selectedParticipantData?.closeDate)
                                    ?.toISOString()
                                    .split("T")[0]
                                : ""
                            }
                          ></input>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="mb-3 col-md-12 mt-4">
                    <button type="submit" className="btn btn-primary me-2">
                      Submit
                    </button>
                    <button
                      type="button"
                      onClick={() => setShowForm(false)}
                      className="btn btn-outline-primary "
                    >
                      Cancel
                    </button>
                  </div>
                </form>
                <div
                  className="ag-theme-alpine"
                  style={{
                    height: "500px",
                    width: "100%",
                  }}
                >
                  <AgGridReact
                    ref={dataGridRefMain}
                    rowData={fundData}
                    columnDefs={columns}
                    animateRows={true}
                    domLayout={"normal"}
                    pagination={true}
                    paginationPageSize={20}
                    className="px-2"
                    rowSelection={"multiple"}
                  ></AgGridReact>
                </div>
              </>
            ) : null}

            {!showForm ? (
              <div
                className="ag-theme-alpine"
                style={{
                  height: "500px",
                  width: "100%",
                }}
              >
                <div className="my-2 col-sm-12 text-end px-3">
                  <i
                    className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
                    style={{ fontSize: "16px" }}
                    onClick={handleExportExcel}
                  ></i>
                  <i
                    className="align-middle far fa-fw fa-file-pdf cursor-pointer"
                    onClick={() => handleExportPdf()}
                    style={{ fontSize: "16px" }}
                  ></i>
                </div>
                <AgGridReact
                  ref={dataGridRefMain}
                  rowData={participantData}
                  columnDefs={participantColumns}
                  animateRows={true}
                  domLayout={"normal"}
                  pagination={true}
                  paginationPageSize={20}
                  className="px-2"
                  rowSelection={"multiple"}
                ></AgGridReact>
              </div>
            ) : null}
          </div>
        </div>
        <Modal
          show={showModal}
          onHide={handleClose}
          centered
          className="modelComponent"
        >
          <Modal.Header closeButton>
            <Modal.Title>Participant data</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you Sure, You want to Delete Participant data
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="submit"
              className="btn-primary"
              size="btn-xs"
              children="Close"
              onClick={handleClose}
            />

            <Button
              type="submit"
              className="btn-primary"
              size="btn-xs"
              children="Delete"
              onClick={handleDelete}
            />
          </Modal.Footer>
        </Modal>
      </div>
      <ToastContainer />
    </div>
  );
};

export { AddParticipant };
